import {
  IssueCardPayload,
  issueNewCard,
  blockCard as blockCardApi,
  getCards,
  batchBalanceByCardNumber,
  batchBalanceByAddress,
  CardApiRecord,
  UpdateCardDataPayload,
  updateCardData,
  SignUpUserPayload,
  signupNewUser,
  PrepareCardIssuancePayload,
  PrepareCardIssuanceResponse,
  prepareCardIssuance as prepareCardIssuanceApi,
  lookupCardApi,
  SpecificCard,
  checkCardTokenApprovals,
  grantCardTokenAproval,
  replaceCardApi,
  suspendCardApi,
  activateCardApi,
} from "utils/AxiosUtil";
import type { NetworkType } from "utils/network";
import type { ApprovalAudit, GrantResult } from "types/approvals";

async function updateCard(
  payload: UpdateCardDataPayload,
  network: NetworkType,
  token: string,
) {
  const res = await updateCardData(payload, network, token);
  return res.data;
}

async function signUpUser(payload: SignUpUserPayload, network: NetworkType) {
  const res = await signupNewUser(payload, network);
  return res.data;
}

// NOT read-only: an existing cardholder handed a new card has it attached here.
async function prepareIssuance(
  payload: PrepareCardIssuancePayload,
  network: NetworkType,
): Promise<PrepareCardIssuanceResponse> {
  const res = await prepareCardIssuanceApi(payload, network);
  return res.data;
}

async function issueCard(payload: IssueCardPayload, network: NetworkType) {
  const res = await issueNewCard(payload, network);
  return res.data;
}

async function blockCard(cardPan: string, network: NetworkType) {
  const res = await blockCardApi(cardPan, network);
  return res.data;
}

async function suspendCard(cardPan: string, network: NetworkType) {
  const res = await suspendCardApi(cardPan, network);
  return res.data;
}

async function activateCard(cardPan: string, network: NetworkType) {
  const res = await activateCardApi(cardPan, network);
  return res.data;
}

async function replaceCard(
  oldCardNumber: string,
  newCardNumber: string,
  network: NetworkType,
) {
  const res = await replaceCardApi(oldCardNumber, newCardNumber, network);
  return res.data;
}

async function lookupCard(
  cardNumber: string,
  network: NetworkType,
  token?: string,
): Promise<SpecificCard> {
  const res = await lookupCardApi(cardNumber, network, token);
  return res.data;
}
async function fetchCards(network: NetworkType): Promise<CardApiRecord[]> {
  return getCards(network);
}

async function fetchBalancesByCardNumbers(
  cardNumbers: string[],
  network: NetworkType,
): Promise<Record<string, number>> {
  return batchBalanceByCardNumber(cardNumbers, network);
}

async function fetchBalancesByAddresses(
  addresses: string[],
  network: NetworkType,
  token?: string,
): Promise<Record<string, number>> {
  return batchBalanceByAddress(addresses, network, token);
}
// Read-only: reports which supported tokens the card's alias is missing an allowance for.
async function checkTokenApprovals(
  cardNumber: string,
  network: NetworkType,
): Promise<ApprovalAudit> {
  const res = await checkCardTokenApprovals(cardNumber, network);
  return res.data;
}

// Sends transactions — a POL top-up, then an `approve` signed by the card's alias. One token,
// named explicitly: the backend refuses an omitted one rather than guessing.
async function grantTokenApproval(
  cardNumber: string,
  token: string,
  network: NetworkType,
): Promise<GrantResult> {
  const res = await grantCardTokenAproval(cardNumber, token, network);
  return res.data;
}

const card_services = {
  issueCard,
  updateCard,
  signUpUser,
  prepareIssuance,
  blockCard,
  suspendCard,
  activateCard,
  replaceCard,
  fetchCards,
  lookupCard,
  fetchBalancesByCardNumbers,
  fetchBalancesByAddresses,
  checkTokenApprovals,
  grantTokenApproval,
};
export default card_services;
